import { Media, MediaProcessingTasks, MediaProcessingTaskStatus, MediaType } from '@pixacare/domain';
import { MEDIA_PLACEHOLDER_THUMBNAIL } from './media-placeholder-thumbnail';

// Derived from content rather than a batch-local index, so two placeholders added in separate
// batches on the same sequence never collide (e.g. the carousel's trackBy keys off this id).
const negativeContentHash = (value: string): number => {
  let hash = 0;
  for (let index = 0; index < value.length; index++) {
    hash = Math.imul(hash, 31) + value.charCodeAt(index);
  }
  return -Math.abs(hash) - 1;
};

// Defaults tasks set by API on medias
const getDefaultProcessingTasks = (type: MediaType): MediaProcessingTasks => {
  switch (type) {
    case MediaType.VIDEO:
      return {
        thumbnail: MediaProcessingTaskStatus.PENDING,
        transcoding: MediaProcessingTaskStatus.PENDING,
        metadata: MediaProcessingTaskStatus.PENDING,
      };
    case MediaType.IMAGE:
      return { thumbnail: MediaProcessingTaskStatus.PENDING };
    default:
      return {};
  }
};

// Optimistic media used to be displayed before the real one returns from API.
export const toOptimisticMedia = (
  clientCode: string,
  sequenceId: number,
  fileName: string,
  fileSize: number,
  type: MediaType,
  previewUri: string = MEDIA_PLACEHOLDER_THUMBNAIL,
): Media => ({
  id: negativeContentHash(`${sequenceId}::${fileName}::${fileSize}`),
  filename: fileName,
  originalFilename: fileName,
  sequenceId,
  clientCode,
  size: fileSize,
  thumbnailUri: previewUri,
  uri: previewUri,
  isAnnoted: false,
  type,
  processingTasks: getDefaultProcessingTasks(type),
});
